module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/heros-6508712a58eb87e61b7ca1c87b6f6196.jpg";